import React, { Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";

import { withStyles } from "@material-ui/core/styles";

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";

//import CancelIcon from '@material-ui/icons/Cancel';

import CircularProgress from "@material-ui/core/CircularProgress";

import * as d3 from "d3";
import { getFileOfCapacity } from "../utils/GetCapacityperProvice";

const CustomTableCell = withStyles((theme) => ({
  head: {
    fontFamily: "Nunito Sans Regular!important",
    fontSize: "14pt",
    textAlign: "center",
    color: "#08716e",
    //fontWeight: 700,
  },
  body: {
    fontFamily: "Nunito Sans Regular",
    fontSize: "14pt",
    color: "#4d4c4c",
  },
}))(TableCell);

const styles = (theme) => ({
  table: {
    fontFamily: "Nunito Sans Regular",
    fontSize: "14pt",
    width: "100%",
    marginTop: "10px",
    overflowX: "auto",
    borderSpacing: "0px",
    borderCollapse: "collapse",
  },
  row: {
    height: "25px",

    //'&:nth-of-type(odd)': {
    //  backgroundColor: theme.palette.background.default,
    //},
  },
  labelCell: {
    //color: '#e2183a!important',
    color: "#08716e",
    [theme.breakpoints.down("xs")]: {
      width: "50%",
    },
    [theme.breakpoints.up("sm")]: {
      width: "45%",
    },
    [theme.breakpoints.up("md")]: {
      width: "40%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "20%",
      fontSize: "11pt",
    },
    [theme.breakpoints.up("xl")]: {
      width: "25%",
    },
    borderBottom: "0px!important",
    minWidth: '78px',
    paddingTop: "4px!important",
    paddingBottom: "4px!important",
  },
  productionValueCell: {
    [theme.breakpoints.down("xs")]: {
      width: "25%",
    },
    [theme.breakpoints.up("sm")]: {
      width: "30%",
    },
    [theme.breakpoints.up("md")]: {
      width: "20%",
      fontSize: "11pt",
    },
    [theme.breakpoints.up("lg")]: {
      width: "35%",
    },
    [theme.breakpoints.up("xl")]: {
      width: "35%",
    },
    textAlign: "right",
    borderBottom: "0px!important",
    paddingTop: "4px!important",
    paddingBottom: "4px!important",
    borderRight:'0px'
    //borderLeft: '1px solid rgba(107,108,110,0.5)',
  },
  familyValueCell: {
    [theme.breakpoints.down("xs")]: {
      width: "25%",
    },
    [theme.breakpoints.up("sm")]: {
      width: "25%",
    },
    [theme.breakpoints.up("md")]: {
      width: "20%",
      fontSize: "11pt",
    },
    [theme.breakpoints.up("lg")]: {
      width: "35%",
    },
    [theme.breakpoints.up("xl")]: {
      width: "40%",
    },
    textAlign: "right",
    borderBottom: "0px!important",
    paddingTop: "4px!important",
    paddingBottom: "4px!important",
    //borderLeft: '1px solid rgba(107,108,110,0.5)',
  },
  totalCell: {
    fontFamily: "Nunito Sans Bold!important",
    borderLeft: "0px!important",
    borderRight: "0px!important",
    borderBottom: "0px!important",
  },
});

const getValueFromRegion = (provinceName, data) => {
  let value;
  switch (provinceName) {
    case "Brabant wallon":
      value = data.get("20002");
      break;
    case "Liège":
      value = data.get("60000");
      break;
    case "Luxembourg":
      value = data.get("80000");
      break;
    case "Hainaut":
      value = data.get("50000");
      break;
    case "Namur":
      value = data.get("90000");
      break;
    default:
      value = "0";
      break;
  }
  return Math.round(value);
};

const getTotalCap = (data) => {
  let value = 0;
  data.forEach((ele) => (value += ele));
  if (value > 100) value /= 1000;
  return Math.round(value * 100) / 100;
};

function ProvinceBox(props) {
  const [showTable, setShowTable] = useState(false);
  const [capacityData, setCapacityData] = useState();

  let capVal;
  function toggleTable() {
    setShowTable((prevShowTable) => !prevShowTable);
  }
  useEffect(() => {
    getFileOfCapacity(
      props.currentTech,
      props.daySelected,
      props.yearSelected,
      props.currentMode
    ).then((val) => setCapacityData(val));
  }, [
    props.currentTech,
    props.daySelected,
    props.yearSelected,
    props.currentMode,
  ]);
  const { classes } = props;
  let overviewData = props.provinceData;
  if (overviewData === undefined)
    return <CircularProgress className={classes.progress} size={50} />;

  const totalProductionData = overviewData["energy_sum"];
  const totalFamilyData = overviewData["nb_household_covered"];

  const provinceData = overviewData["energy_per_province"];
  const familyData = overviewData["family_per_province"];

  let production;
  let numberFamilies;
  let totalWallonie;
  let windOffshore;
  let northSea;
  let capacity;
  //let totalWallonieNorthSea

  //let energyTypeWithoutOffshore

  let inh;
  let localeOption;

  switch (props.lang) {
    case "de":
      production = "Produktion";
      numberFamilies = "Anzahl der Haushalte";
      totalWallonie = "Gesamt (Wallonie)";
      windOffshore = "Wind offshore";
      northSea = "Nordmeer";
      capacity = "Kapazität";
      //totalWallonieNorthSea = "Gesamt (Wallonie + Nordmeer)"
      /*
      energyTypeWithoutOffshore = (
        props.currentTech.solar ? (
          props.currentTech.wind ? "Sonne und Wind onshore" : "Sonne"
        )
          : props.currentTech.wind ? "Wind onshore" : ""
      )
    */
      localeOption = "de-DE";

      inh = "Einw";
      break;
    case "en":
      production = "Production";
      numberFamilies = "Number families";
      totalWallonie = "Total (Wallonia)";
      windOffshore = "Wind offshore";
      northSea = "North sea";
      capacity = "Capacity";
      //totalWallonieNorthSea = "Total (Wallonia + North sea)"
      /*      
      energyTypeWithoutOffshore = (
        props.currentTech.solar ? (
          props.currentTech.wind ? "solar and wind onshore" : "solar"
        )
          : props.currentTech.wind ? "Wind onshore" : ""
      )
    */
      localeOption = "en-GB";

      inh = "inh";
      break;
    case "fr":
    default:
      production = "Production";
      numberFamilies = "Nombre foyers";
      totalWallonie = "Total (Wallonie)";
      windOffshore = "Éolienne offshore";
      northSea = "Mer du nord";
      capacity = "Capacité";
      //totalWallonieNorthSea = "Total (Wallonie + Mer du nord)"
      /*      
      energyTypeWithoutOffshore = (
        props.currentTech.solar ? (
          props.currentTech.wind ? "solaire et éolienne onshore" : "solaire"
        )
          : props.currentTech.wind ? "éolienne onshore" : ""
      )
    */
      localeOption = "fr-BE";

      inh = "hab";
  }
  /*
  let periodIdentification
  switch (props.currentMode) {
    case 'realtime':
      periodIdentification = props.daySelected.substring(6, 8) + "." + props.daySelected.substring(4, 6) + "." + props.daySelected.substring(0, 4)
      break;
    case 'historical':
    default:
      periodIdentification = props.yearSelected
  }
*/
  const unitHour = "MWh";
  const unitMonth = "GWh";
  /*
  switch (props.currentFilter) {
    case 'inhabitants':
      unitHour = 'Wh/' + inh;
      unitMonth = 'kWh/' + inh;
      break;
    case 'surface':
      unitHour = 'MWh/km²';
      unitMonth = 'GWh/km²';
      break;
    default:
    case 'energy':
      unitHour = 'MWh';
      unitMonth = 'GWh';
  }
  */
  const currentYear = parseInt(d3.timeFormat("%Y")(new Date()));
  const energyUsePerFamily =
    props.currentMode === "realtime"
      ? 3500 / 365.25
      : props.yearSelected === currentYear
      ? props.data !== undefined && props.data.length > 0
        ? (3500 * props.data.length) / 12
        : 0
      : 3500;
  const offshoreEnergyProduction = isNaN(props.offshoreEnergyProduction)
    ? "0"
    : props.currentMode === "realtime"
    ? //(props.currentFilter === 'inhabitants' ?
      //  (props.offshoreEnergyProduction * 10) :
      Math.round(props.offshoreEnergyProduction)
    : //)
      //(props.currentFilter === 'inhabitants' ?
      //  (Math.floor(props.offshoreEnergyProduction / 10) / 10) :
      Math.floor(props.offshoreEnergyProduction);
  //)
  const offshoreEnergyUnit =
    props.currentMode === "realtime" ? unitHour : unitMonth;
  let capacityVar = null;

  return (
    <Fragment>
      {Object.keys(props.provinceData).length > 0 && (
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <CustomTableCell className="darkGrey">
                {" "}
                {/*energyTypeWithoutOffshore periodIdentification*/}
              </CustomTableCell>
              <CustomTableCell
                style={{ fontSize: "11pt" }}
                className="mediumgreen"
              >
                {capacity}
              </CustomTableCell>
              <CustomTableCell
                style={{ fontSize: "11pt" }}
                className="mediumgreen"
              >
                {production}
              </CustomTableCell>
              <CustomTableCell
                style={{ fontSize: "11pt" }}
                className="mediumgreen"
              >
                {numberFamilies}
              </CustomTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.keys(provinceData)
              .filter((provinceName) => provinceName !== "Mer du nord (B)")
              .map((provinceName) => (
                <TableRow className={classes.row} key={provinceName}>
                  <CustomTableCell
                    className={classes.labelCell + " mediumgreen"}
                  >
                    {provinceName}
                  </CustomTableCell>
                  <CustomTableCell className={classes.productionValueCell}>
                    {getValueFromRegion(provinceName, capacityData).toLocaleString(
                      localeOption
                    )} MW
                  </CustomTableCell>
                  <CustomTableCell className={classes.productionValueCell}>
                    {parseInt(provinceData[provinceName].value).toLocaleString(
                      localeOption
                    )}{" "}
                    {provinceData[provinceName].unit}
                  </CustomTableCell>
                  <CustomTableCell className={classes.familyValueCell}>
                    {parseInt(familyData[provinceName].value).toLocaleString(
                      localeOption
                    )}
                  </CustomTableCell>
                </TableRow>
              ))}
            <TableRow
              className={classes.totalRow}
              style={{ textAlign: "right" }}
            >
              <CustomTableCell
                className={
                  classes.labelCell + " mediumgreen " + classes.totalCell
                }
              >
                {totalWallonie}:
              </CustomTableCell>
              <CustomTableCell
                className={
                  classes.productionValueCell + " " + classes.totalCell
                }
              >
                {getTotalCap(capacityData).toLocaleString(
                  localeOption
                )} GW
              </CustomTableCell>
              <CustomTableCell
                className={
                  classes.productionValueCell + " " + classes.totalCell
                }
              >
                {parseFloat(totalProductionData.value).toLocaleString(
                  localeOption
                )}{" "}
                {totalProductionData.unit}
              </CustomTableCell>
              <CustomTableCell
                className={classes.familyValueCell + " " + classes.totalCell}
              >
                {parseInt(totalFamilyData.value).toLocaleString(localeOption)}
              </CustomTableCell>
            </TableRow>
          </TableBody>
        </Table>
      )}
      {
        props.currentTech.windOffshore && (
          <Table className={classes.table}>
            <TableBody>
              <TableRow className={classes.row}>
                <CustomTableCell className={classes.labelCell + " mediumgreen"}>
                  {northSea}
                </CustomTableCell>
                <CustomTableCell className={classes.productionValueCell}>
                  {Math.round(capacityData.get("windOffshore")).toLocaleString(
                    localeOption
                  )}{" "}
                  {offshoreEnergyUnit.replace('h','')}
                </CustomTableCell>
                <CustomTableCell className={classes.productionValueCell}>
                  {Math.round(offshoreEnergyProduction).toLocaleString(
                    localeOption
                  )}{" "}
                  {offshoreEnergyUnit}
                </CustomTableCell>
                <CustomTableCell className={classes.familyValueCell}>
                  {Math.round(
                    (offshoreEnergyProduction / energyUsePerFamily) * 1000
                  ).toLocaleString(localeOption)}
                </CustomTableCell>
              </TableRow>
            </TableBody>
          </Table>
        )
        /*
        props.currentTech.windOffshore && (
        <Table
          className={classes.table}
        >
          <TableHead>
            <TableRow>
              <CustomTableCell className="darkGrey"> </CustomTableCell>
              <CustomTableCell className="mediumgreen">{production}</CustomTableCell>
              <CustomTableCell className="mediumgreen">{numberFamilies}</CustomTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow className={classes.totalRow} style={{ textAlign: 'right' }}>
              <CustomTableCell className={classes.labelCell + " " + classes.totalCell}>{totalWallonieNorthSea}</CustomTableCell>
              <CustomTableCell className={classes.productionValueCell + " " + classes.totalCell}>{parseFloat(totalProductionData.value).toLocaleString('nl-BE', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} {totalProductionData.unit}</CustomTableCell>
              <CustomTableCell className={classes.familyValueCell + " " + classes.totalCell}>{parseInt(totalFamilyData.value).toLocaleString('nl-BE')}</CustomTableCell>
            </TableRow>
          </TableBody>
        </Table>
      )
          */
      }
    </Fragment>
  );
}
ProvinceBox.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProvinceBox);
